import anime from 'animejs/lib/anime.es.js';

export function anniversaryInterviewFunc() {
    let anniversaryInterview = $('#anniversaryInterview').length;
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

    if (anniversaryInterview) {
        $('#mainKv #imgBox').addClass('active');
        $('#mainKvTit').addClass('active');
        $('#mainKvLead').addClass('active');
        $('#txtBox02').addClass('active');
        
        let scrollAnimationFlag01 = false;
        
        var flug = true;
        $(window).scroll(function () {
            if (flug) {
                flug = false;
                setTimeout(function () {
                    // ここに処理を書く

                    let fade = $('.fade').offset().top;
                    
                    //fade in
                    $('.interviewBox').each(function () {
                        var position = $(this).offset().top;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        
                        if (scroll > position - windowHeight + 50) {
                            
                            wait(0)
                                .then(() => {
                                    $(this).addClass('active');
                                    return wait(600)
                                })
                                .then(() => {
                                    $(this).find('.imgBox').addClass('active');
                                    return wait(600)
                                })
                            
                        }
                    });
                    
                    $('#interviewFuture').each(function () {
                        var position = $(this).offset().top;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        
                        if (scroll > position - windowHeight + 50) {
                            
                            wait(0)
                                .then(() => {
                                    $('#interviewFutureTit').addClass('active');
                                    return wait(600)
                                })
                                .then(() => {
                                    $('#gradationLine').addClass('active');
                                    return wait(600)
                                })
                                .then(() => {
                                    $('#interviewFutureSubTit').addClass('active');
                                    return wait(600)
                                })
                                .then(() => {
                                    $('#interviewFutureTxt').addClass('active');
                                    return wait(600)
                                })
                            
                        }
                    });
                    
                    $('#interviewProfile').each(function () {
                        var position = $(this).offset().top;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        
                        if (scroll > position - windowHeight + 50) {
                            
                            $(this).addClass('active');
                            
                        }
                    });
                    
                    $('#nextInterviewBox').each(function () {
                        var position = $(this).offset().top;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        
                        if (scroll > position - windowHeight + 50) {
                            
                            $(this).addClass('active');
                            
                        }
                    });

                    flug = true;
                    return flug;
                }, 500);
            }
        });
    }
}